import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { GoogleLogin, GoogleLoginResponse } from 'react-google-login'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { toast } from 'react-toastify'
import { History } from 'history'
import { RootState } from '../../store'
import { tokenSave, authLogout } from '../../store/auth/actions'
import { AuthStatus } from '../../store/auth/reducer'
import { authenticate } from '../../lib/api/auth'
import * as queryString from 'query-string'

const { REACT_APP_GOOGLE_ID = '' } = process.env

type AccountPageProps = {
  authStatus: AuthStatus,
  history: History,
  onAuthenticate: (token: string, Function: any) => void,
  onLogout: () => void,
}

class AccountPage extends React.Component<AccountPageProps> {

  constructor(props: AccountPageProps) {
    super(props)    

    if (props.authStatus && props.authStatus !== 'initial') {
      props.onLogout()
    }

    const { onAuthenticate, history } = this.props
    
    // Parse query params and look for authToken    
    const { authToken } = queryString.parse(history.location.search)
    if (authToken) {      
      onAuthenticate(authToken as any, (err) => {
        if (err) {
          toast(`Error while fetching user: ${err}`)
          return
        }
        
        window.close()
      })
    }
  }

  handleSuccess = (response: GoogleLoginResponse) => {
    const { onAuthenticate } = this.props
    const auth = response.getAuthResponse()

    authenticate(auth.id_token)
      .then((user: any) => onAuthenticate(user.access_token, (err) => {
        if (err) {
          toast(`Error while fetching user: ${err}`)
          return
        }
        const { history } = this.props
        history.replace('/dashboard')
      }))
      .catch((err) => toast.error('User not authorized, please try again.'))
  }

  handleFailure = ({ error }: { error: string }) => {
    console.log('failure', error)

    if (error !== 'popup_closed_by_user') {
      toast.error('Error logging in, please try again.')
    }
  }

  render() {
    return (
      <div className="container">
        <div className="text-center p-4">
          <GoogleLogin
            clientId={REACT_APP_GOOGLE_ID}
            onFailure={this.handleFailure}
            onSuccess={this.handleSuccess}
            render={({ onClick }: { onClick: () => void }) => (
              <button className="btn btn-warning" onClick={onClick}>
                <FontAwesomeIcon icon={["fab", "google"]} className="mr-2" />
                Please log in to continue
              </button>
            )}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ auth }: RootState): any => ({
  authStatus: auth.status,
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onAuthenticate: (token: string, next: () => void) => dispatch(tokenSave(token, next)),
  onLogout: () => dispatch(authLogout()),
})

export default connect<AccountPageProps>(mapStateToProps, mapDispatchToProps)(AccountPage)



// WEBPACK FOOTER //
// ./src/routes/account/index.tsx